export const KB_ARTICLE_STATUSES = ['DRAFT', 'PUBLISHED'] as const;
export type KbArticleStatus = (typeof KB_ARTICLE_STATUSES)[number];
